<template>
  <div :id="cardId" class="vs-con-loading__container">
    <vx-card>
      <card-header
        :title="$t('complementary_payrolls')"
        v-model="params.search"
        @search="search"
        @close="close"
      />
      <complementary-payrolls-table
        :data="items"
        @showDetails="showDetails"
        @loadMore="loadMore"
        @search="search"
      />
    </vx-card>
  </div>
</template>



<script>
import ComplementaryPayrollsTable from '../tables/ComplementaryPayrollsTable.vue'
import dashboard from '@/http/requests/dashboard'
import CardHeader from '../components/CardHeader.vue'

export default {
  name: 'ehs-card',
  components: {
    ComplementaryPayrollsTable,
    CardHeader
  },
  props: {

  },
  data() {
    return {
      cardTitle: 'Titulo',
      cardId: 'loading-complementary-payrolls-card',
      items: [],
      item: '',
      lastPage: 1,
      loading: false,
      params: {
        page: 1,
        search: '',
        groupBy: [
            "cl.ClientName",
            "payroll_no",
            "payrolls.total",
            "payrolls.created_at",
            "P.WeekInvoice",
            "I.PackageNumber"
        ]
      },
    }
  },
  methods: {
    getData() {
      this.loading = true
      window.scrollTo(0,document.body.scrollHeight);
      dashboard
        .complementaryPayrollsTable(this.params)
        .then((response) => {
          if (this.params.page === 1) {
            this.items = []
            this.items = [...response.data.data]
          } else {
            this.items = [...this.items, ...response.data.data]
          }
          this.lastPage = response.data.last_page
          this.loading = false
        })
        .catch((response) => {
          this.showValidationErrors(response)
          this.loading = false
        })
    },
    loadMore() {
      if (this.params.page >= this.lastPage) {
        return
      }
      this.params.page++
      this.getData()
    },
    search() {
      this.params.page = 1
      this.getData()
    },
    close() {
      this.$emit('close', false)
    },
    showDetails(id) {
      this.item = id
      this.$store.dispatch('toggleSidebar', 'sidebar-ehs-details')
    },
  },
  mounted(){
    this.search()
  },
  watch: {
    loading(val) {
      if (val) {
        this.$vs.loading({
          container: `#${this.cardId}`,
          scale: 0.45,
        })
      } else {
        this.$vs.loading.close(`#${this.cardId} > .con-vs-loading`)
      }
    },
    data(){
      this.search()
    }
  },

}
</script>

